import "./_quiz.scss";
import { gsap } from "gsap";
import "parsleyjs";
import Swal from "sweetalert2";

import "jquery-ui/ui/widgets/autocomplete";

import { __ } from "@wordpress/i18n";

$(function () {


	function stepTransitionBack(btnBack) {
		var stepTransitionBack = gsap.timeline({ repeat: 0, repeatDelay: 1 });
		var transitionSpeed = 0.2;
		var currentStep = parseInt(btnBack.data("step"));
		var firstStep = 1;

		if (currentStep >= firstStep) {
			$(".sidebar__list-item").removeClass("active");
			$('.sidebar__list-item[data-step="' + (currentStep - 1) + '"]').addClass(
				"active"
			);

			stepTransitionBack.to(
				$(
					".quiz__back-btn[data-step='" + currentStep + "']"
				).closest(".quiz__step"),
				{ duration: transitionSpeed, x: +150, opacity: 0 }
			);
			stepTransitionBack.set(
				$(
					".quiz__back-btn[data-step='" + currentStep + "']"
				).closest(".quiz__step"),
				{ display: "none" }
			);
			stepTransitionBack.set(
				$(
					".quiz__back-btn[data-step='" + (currentStep - 1) + "']"
				).closest(".quiz__step"),
				{ display: "flex", opacity: 0, x: -150 }
			);
			stepTransitionBack.to(
				$(
					".quiz__back-btn[data-step='" + (currentStep - 1) + "']"
				).closest(".quiz__step"),
				{ duration: transitionSpeed, x: 0, opacity: 1 }
			);
		}
	}
	function stepTransitionNext(btnNext) {
		var stepTransitionNext = gsap.timeline({ repeat: 0, repeatDelay: 1 });
		var transitionSpeed = 0.2;

		var currentStep = parseInt(btnNext.data("step"));
		var lastStep = parseInt($("button.last-step").data("step"));

		if (currentStep < lastStep) {
			stepTransitionNext.to(
				$(
					".quiz__next-btn[data-step='" + currentStep + "']"
				).closest(".quiz__step"),
				{ duration: transitionSpeed, x: -150, opacity: 0 }
			);
			stepTransitionNext.set(
				$(
					".quiz__next-btn[data-step='" + currentStep + "']"
				).closest(".quiz__step"),
				{ display: "none" }
			);
			stepTransitionNext.set(
				$(
					".quiz__next-btn[data-step='" + (currentStep + 1) + "']"
				).closest(".quiz__step"),
				{ display: "flex", opacity: 0, x: 150 }
			);
			stepTransitionNext.to(
				$(
					".quiz__next-btn[data-step='" + (currentStep + 1) + "']"
				).closest(".quiz__step"),
				{ duration: transitionSpeed, x: 0, opacity: 1 }
			);
		}
	}

	//PARLSLEY DATA VALIDATION
	$('#quiz').parsley();
	//END PARLSLEY DATA VALIDATION


	///

	var sections = $(".quiz__step");
	// Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
	$(sections).each(function (index, section) {
		$(section)
			.find(":input")
			.attr("data-parsley-group", "block-" + index);
	});

	$(".quiz__next-btn").on("click", function (e) {
		var btn = $(this);
		var parsleyStep = $(this).attr("data-step");
		$("#quiz")
			.parsley()
			.whenValidate({
				group: "block-" + (parseInt(parsleyStep) - 1),
			})
			.done(function () {
				stepTransitionNext(btn);
			});
		//stepTransitionNext($(this));
        //stepTransitionNext(btn);
	});
	$(".quiz__back-btn").on("click", function (e) {
		stepTransitionBack($(this));
	});

	//ADJUST PARSLEY ERROR MESSAGES

	$("#quiz")
		.parsley()
		.on("form:error", function () {
			$(".parsley-error").closest(".form-row").css("margin-bottom", "30px");
			var errorCheckBoxes = $(".checkboxes.parsley-error");

			//CHECKBOXES
			var errorCheckBoxParent = Array();
			var errorCheckBoxesParentHeight = Array();
			$(errorCheckBoxes).each(function (index, element) {
				// element == this
				errorCheckBoxParent[index] = $(element).parent();
				errorCheckBoxesParentHeight[index] =
					errorCheckBoxParent[index].height();

				errorCheckBoxParent[index].css("border", "1px solid red");
				$(element).addClass("parsley-error-inhibit-border");
				$(element)
					.siblings(".parsley-errors-list")
					.css("position", "absolute")
					.css("top", errorCheckBoxesParentHeight[index] - 20 + "px")
					.css("left", "0px");

				$(element)
					.parent()
					.find("input")
					.on("change", function (e) {
						$(".checkboxes.parsley-success")
							.closest(".form-check")
							.addClass("parsley-error-inhibit-border");
						$(".checkboxes.parsley-error")
							.closest(".form-check")
							.removeClass("parsley-error-inhibit-border");
					});
			});

			//SELECTS
			var errorSelect = $(".quiz__select.parsley-error");
			$(errorSelect).each(function (index, element) {
				// element == this

				//$(element).addClass('parsley-error-inhibit-border');
				$(element)
					.siblings(".select2-container")
					.find(".select2-selection--single")
					.css("border-color", "red");

				$(element)
					.siblings(".parsley-errors-list")
					.css("position", "absolute")
					.css("top", 40 + "px")
					.css("left", "0px");

				$(element).on("change", function (e) {
					$(".parsley-success")
						.siblings(".select2-container")
						.find(".select2-selection--single")
						.addClass("mammi-parsley-select-standard-border");
					$(".parsley-error")
						.siblings(".select2-container")
						.find(".select2-selection--single")
						.removeClass("mammi-parsley-select-standard-border");
				});
			});
		});

	//END ADJUST PARSLEY ERROR MESSAGES



	//
	function refreshFormPage() {
		location.reload();
	}
	$("#quiz").on("submit", function (event) {
		event.preventDefault();

		var self = $(this);
		var primaryTag = self.closest("form").attr("data-subtype");
		var secondaryTag = self.closest("form").attr("data-subsubtype");

		//var fd = new FormData($("#quiz")[0]);
		/* fd.append(
			"quiz__main-image",
			$("#quiz_featured-image")[0].files[0]
		);
		fd.append(
			"quiz_gallery-image-1",
			$("#quiz_gallery-image-1")[0].files[0]
		);
		fd.append(
			"quiz_gallery-image-2",
			$("#quiz_gallery-image-2")[0].files[0]
		);
		fd.append(
			"quiz_gallery-image-3",
			$("#quiz_gallery-image-3")[0].files[0]
		);
		fd.append(
			"quiz_gallery-image-4",
			$("#quiz_gallery-image-4")[0].files[0]
		); */
		//fd.append("action", "request_quiz_jobs");

		$("#quiz #btn-submit").prop("disabled", "true");
		$("body").append(
			'<div class="we-loading"><div class="we-loading__image-container"><svg xmlns="http://www.w3.org/2000/svg" style="margin:auto;background:transparent" width="200" height="200" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" display="block"><circle cx="30" cy="50" fill="#012263" r="20"><animate attributeName="cx" repeatCount="indefinite" dur="1s" keyTimes="0;0.5;1" values="30;70;30" begin="-0.5s"/></circle><circle cx="70" cy="50" fill="#46dff0" r="20"><animate attributeName="cx" repeatCount="indefinite" dur="1s" keyTimes="0;0.5;1" values="30;70;30" begin="0s"/></circle><circle cx="30" cy="50" fill="#012263" r="20"><animate attributeName="cx" repeatCount="indefinite" dur="1s" keyTimes="0;0.5;1" values="30;70;30" begin="-0.5s"/><animate attributeName="fill-opacity" values="0;0;1;1" calcMode="discrete" keyTimes="0;0.499;0.5;1" dur="1s" repeatCount="indefinite"/></circle></svg></div>"</div>'
		);
		$.ajax({
			url: ajax_object.ajaxurl,
			type: "POST",
			//processData: false,
			//contentType: false,
			dataType: "html",
			//contentType: 'text/html',
			//data: fd,
			data: {
				action: "request_quiz_jobs",
				primary_tag: primaryTag,
				secondary_tag: secondaryTag,
				security: ajax_object.ajax_nonce,
			},
			success: function (data) {
				var response = JSON.parse(data);
				$(".we-loading").remove();
				console.log(response);

				$(".quiz").html(response.data);

				if (window.history.replaceState) {
					window.history.replaceState(null, null, window.location.href);
				}
			},
		});
		//return false;
	});
	//

	$("label:contains(Multi-color)")
		.closest(".controls-label-container")
		.css("order", "100");
	$("label:contains(Other)")
		.closest(".controls-label-container")
		.css("order", "200");

});


//MYVIP
$(function () {
	//DETERMINE IS AB OR CD
	$(".quiz__content--first-set input[type=radio]").on("change", function (e) {
		e.preventDefault();

		var selectedRadio = $(this);

		var firstSetSelectedValuesColectionArray = [];
		$(".quiz__content--first-set input[type=radio]:checked").each(function (
			index,
			element
		) {
			// element == this
			firstSetSelectedValuesColectionArray.push($(element).val());
		});

		console.log(firstSetSelectedValuesColectionArray);

		const countsChoises = {};

		for (const num of firstSetSelectedValuesColectionArray) {
			countsChoises[num] = countsChoises[num] ? countsChoises[num] + 1 : 1;
		}

		console.log(countsChoises);

		if (
			$(".quiz__content--first-set .answer").length ==
			$(".quiz__content--first-set input[type=radio]:checked").length
		) {
			if (countsChoises.ab > countsChoises.cd || countsChoises.hasOwnProperty('cd')==false) {
				$("form#quiz").attr("data-main-type", "ab");
				//REMOVE REQUIRED FROM CD IN NEXT SET
				$(".quiz__content--c-or-d input").removeAttr("required");
				$(".quiz__content--a-or-b input").attr("required", "true");
			} else if(countsChoises.cd > countsChoises.ab || countsChoises.hasOwnProperty('ab')==false) {
				$("form#quiz").attr("data-main-type", "cd");
				//REMOVE REQUIRED FROM AB IN NEXT SET
				$(".quiz__content--a-or-b input").removeAttr("required");
				$(".quiz__content--c-or-d input").attr("required", "true");
			}

			/* $(".quiz-message").text(
				"User is " + $("form#quiz").attr("data-main-type")
			); */
		}
	});

	//END DETERMINE IS AB OR CD

	//DETERMINE IS A,B OR C,D

	$(".quiz__content--second-set input[type=radio]").on("change", function (e) {
		e.preventDefault();

		if ($("form#quiz").attr("data-main-type") == "ab") {
			var selectedRadio = $(this);

			var secondSetSelectedValuesColectionArray = [];
			$(".quiz__content--a-or-b input[type=radio]:checked").each(function (
				index,
				element
			) {
				// element == this
				secondSetSelectedValuesColectionArray.push($(element).val());
			});

			console.log(secondSetSelectedValuesColectionArray);

			const countsChoises = {};

			for (const num of secondSetSelectedValuesColectionArray) {
				countsChoises[num] = countsChoises[num] ? countsChoises[num] + 1 : 1;
			}

			console.log(countsChoises);

			if (
				$(".quiz__content--a-or-b .answer").length ==
				$(".quiz__content--a-or-b input[type=radio]:checked").length
			) {
				if (countsChoises.a > countsChoises.b || countsChoises.hasOwnProperty('b')==false ) {
					$("form#quiz").attr("data-subtype", "a");
					$(".quiz__content--focused input").attr("required", "true");
					$(".quiz__content--practical input").removeAttr("required");
					$(".quiz__content--creative input").removeAttr("required");
					$(".quiz__content--curious input").removeAttr("required");
				} else if(countsChoises.b > countsChoises.a || countsChoises.hasOwnProperty('a')==false ) {
					$("form#quiz").attr("data-subtype", "b");
					$(".quiz__content--practical input").attr("required", "true");
					$(".quiz__content--focused input").removeAttr("required");
					$(".quiz__content--creative input").removeAttr("required");
					$(".quiz__content--curious input").removeAttr("required");
				}

				/* $(".quiz-message").text(
					"User is " +
						$("form#quiz").attr("data-main-type") +
						", " +
						$("form#quiz").attr("data-subtype")
				); */
			}
		}
		if ($("form#quiz").attr("data-main-type") == "cd") {
			var selectedRadio = $(this);

			var secondSetSelectedValuesColectionArray = [];
			$(".quiz__content--c-or-d input[type=radio]:checked").each(function (
				index,
				element
			) {
				// element == this
				secondSetSelectedValuesColectionArray.push($(element).val());
			});

			console.log(secondSetSelectedValuesColectionArray);

			const countsChoises = {};

			for (const num of secondSetSelectedValuesColectionArray) {
				countsChoises[num] = countsChoises[num] ? countsChoises[num] + 1 : 1;
			}

			console.log(countsChoises);

			if (
				$(".quiz__content--c-or-d .answer").length ==
				$(".quiz__content--c-or-d input[type=radio]:checked").length
			) {
				if (countsChoises.c > countsChoises.d || countsChoises.hasOwnProperty('d')==false ) {
					$("form#quiz").attr("data-subtype", "c");
					$(".quiz__content--creative input").attr("required", "true");
					$(".quiz__content--practical input").removeAttr("required");
					$(".quiz__content--focused input").removeAttr("required");
					$(".quiz__content--curious input").removeAttr("required");
				} else if(countsChoises.d > countsChoises.c || countsChoises.hasOwnProperty('c')==false ){
					$("form#quiz").attr("data-subtype", "d");
					$(".quiz__content--curious input").attr("required", "true");
					$(".quiz__content--practical input").removeAttr("required");
					$(".quiz__content--creative input").removeAttr("required");
					$(".quiz__content--focused input").removeAttr("required");
				}

				/* $(".quiz-message").text(
					"User is " +
						$("form#quiz").attr("data-main-type") +
						", " +
						$("form#quiz").attr("data-subtype")
				); */
			}
		}
	});

	//END DETERMINE IS A,B OR C,D

	//5TH STEP - IS CREATIVE, CURIOUS, PRACTICAL, FOCUSED

	$(".quiz__content--third-set input[type=radio]").on("change", function (e) {
		e.preventDefault();

		if ($("form#quiz").attr("data-subtype") == "a") {
			var selectedRadio = $(this);

			var thirdSetSelectedValuesColectionArray = [];

			$(".quiz__content--focused input[type=radio]:checked").each(function (
				index,
				element
			) {
				// element == this
				thirdSetSelectedValuesColectionArray.push($(element).val());
			});

			const countsChoises = {};

			for (const num of thirdSetSelectedValuesColectionArray) {
				countsChoises[num] = countsChoises[num] ? countsChoises[num] + 1 : 1;
			}

			console.log(countsChoises);

			if (
				$(".quiz__content--focused .answer").length ==
				$(".quiz__content--focused input[type=radio]:checked").length
			) {
				var subSubType;
				if(countsChoises.p > countsChoises.n || countsChoises.hasOwnProperty('n')==false) {
						subSubType = 'focused';
						$("form#quiz").attr("data-subsubtype", subSubType);
						/* $(".quiz-message").text(
							"User is " +
								$("form#quiz").attr("data-main-type") +
								", " +
								$("form#quiz").attr("data-subtype") +
								", " +
								$("form#quiz").attr("data-subsubtype")
						); */
					} else if(countsChoises.n > countsChoises.p || countsChoises.hasOwnProperty('p')==false){
						subSubType = "";
						$("form#quiz").attr("data-subsubtype", subSubType);
						/* $(".quiz-message").text(
							"User is " +
								$("form#quiz").attr("data-main-type") +
								", " +
								$("form#quiz").attr("data-subtype") +
								", " +
								$("form#quiz").attr("data-subsubtype")
						); */
				}

				

			}
			

			
	
		}

		if ($("form#quiz").attr("data-subtype") == "b") {
			var selectedRadio = $(this);

			var thirdSetSelectedValuesColectionArray = [];

			$(".quiz__content--practical input[type=radio]:checked").each(function (
				index,
				element
			) {
				// element == this
				thirdSetSelectedValuesColectionArray.push($(element).val());
			});

			const countsChoises = {};

			for (const num of thirdSetSelectedValuesColectionArray) {
				countsChoises[num] = countsChoises[num] ? countsChoises[num] + 1 : 1;
			}

			console.log(countsChoises);

			if (
				$(".quiz__content--practical .answer").length ==
				$(".quiz__content--practical input[type=radio]:checked").length
			) {
				var subSubType;
				if (
					countsChoises.p > countsChoises.n ||
					countsChoises.hasOwnProperty("n") == false
				) {
					subSubType = "practical";
					$("form#quiz").attr("data-subsubtype", subSubType);
					/* $(".quiz-message").text(
						"User is " +
							$("form#quiz").attr("data-main-type") +
							", " +
							$("form#quiz").attr("data-subtype") +
							", " +
							$("form#quiz").attr("data-subsubtype")
					); */
				} else if (
					countsChoises.n > countsChoises.p ||
					countsChoises.hasOwnProperty("p") == false
				) {
					subSubType = "";
					$("form#quiz").attr("data-subsubtype", subSubType);
					/* $(".quiz-message").text(
						"User is " +
							$("form#quiz").attr("data-main-type") +
							", " +
							$("form#quiz").attr("data-subtype") +
							", " +
							$("form#quiz").attr("data-subsubtype")
					); */
				}
			}
		}

		if ($("form#quiz").attr("data-subtype") == "c") {
			var selectedRadio = $(this);

			var thirdSetSelectedValuesColectionArray = [];

			$(".quiz__content--creative input[type=radio]:checked").each(function (
				index,
				element
			) {
				// element == this
				thirdSetSelectedValuesColectionArray.push($(element).val());
			});

			const countsChoises = {};

			for (const num of thirdSetSelectedValuesColectionArray) {
				countsChoises[num] = countsChoises[num] ? countsChoises[num] + 1 : 1;
			}

			console.log(countsChoises);

			if (
				$(".quiz__content--creative .answer").length ==
				$(".quiz__content--creative input[type=radio]:checked").length
			) {
				var subSubType;
				if (
					countsChoises.p > countsChoises.n ||
					countsChoises.hasOwnProperty("n") == false
				) {
					subSubType = "creative";
					$("form#quiz").attr("data-subsubtype", subSubType);
					/* $(".quiz-message").text(
						"User is " +
							$("form#quiz").attr("data-main-type") +
							", " +
							$("form#quiz").attr("data-subtype") +
							", " +
							$("form#quiz").attr("data-subsubtype")
					); */
				} else if (
					countsChoises.n > countsChoises.p ||
					countsChoises.hasOwnProperty("p") == false
				) {
					subSubType = "";
					$("form#quiz").attr("data-subsubtype", subSubType);
					/* $(".quiz-message").text(
						"User is " +
							$("form#quiz").attr("data-main-type") +
							", " +
							$("form#quiz").attr("data-subtype") +
							", " +
							$("form#quiz").attr("data-subsubtype")
					); */
				}
			}
		}

		if ($("form#quiz").attr("data-subtype") == "d") {
			var selectedRadio = $(this);

			var thirdSetSelectedValuesColectionArray = [];

			$(".quiz__content--curious input[type=radio]:checked").each(function (
				index,
				element
			) {
				// element == this
				thirdSetSelectedValuesColectionArray.push($(element).val());
			});

			const countsChoises = {};

			for (const num of thirdSetSelectedValuesColectionArray) {
				countsChoises[num] = countsChoises[num] ? countsChoises[num] + 1 : 1;
			}

			console.log(countsChoises);

			if (
				$(".quiz__content--curious .answer").length ==
				$(".quiz__content--curious input[type=radio]:checked").length
			) {
				var subSubType;
				if (
					countsChoises.p > countsChoises.n ||
					countsChoises.hasOwnProperty("n") == false
				) {
					subSubType = "curious";
					$("form#quiz").attr("data-subsubtype", subSubType);
					/* $(".quiz-message").text(
						"User is " +
							$("form#quiz").attr("data-main-type") +
							", " +
							$("form#quiz").attr("data-subtype") +
							", " +
							$("form#quiz").attr("data-subsubtype")
					); */
				} else if (
					countsChoises.n > countsChoises.p ||
					countsChoises.hasOwnProperty("p") == false
				) {
					subSubType = "";
					$("form#quiz").attr("data-subsubtype", subSubType);
					/* $(".quiz-message").text(
						"User is " +
							$("form#quiz").attr("data-main-type") +
							", " +
							$("form#quiz").attr("data-subtype") +
							", " +
							$("form#quiz").attr("data-subsubtype")
					); */
				}
			}
		}
	});
});

